import { CALL_API } from '../middleware/api';
import actionTypes from './actionTypes.js';
import { makeFSATripplet } from './utils';

function fetchCitySuggestions(data) {
  return {
    [CALL_API]: {
      types: makeFSATripplet(actionTypes.CITY_AUTOCOMPLETE),
      endpoint: 'geo/city/autocomplete/',
      method: 'get',
      data
    }
  };
}

export function loadCitySuggestions(value) {
  return (dispatch, getState) => {
    return dispatch(fetchCitySuggestions({ q: value}));
  };
}



// WEBPACK FOOTER //
// ./src/actions/geoActions.js